module.exports = __webpack_public_path__ + "static/img/Ellipse_bjr.9435dd0d.png";